import * as z from "zod";

export const createColorSchemeBodySchema = z
  .object({ id: z.number() })
  .nonstrict();

export type CreateColorScheme = z.infer<typeof createColorSchemeBodySchema>;

export type ColorName = "color_12" | "color_13" | "color_14" | "color_15";
